import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    Button,
    IconButton,
    Checkbox,
    FormControlLabel,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DoctorEngagementPaymentModal from "./DoctorEngagementPaymentModal";

const HowToPayModal = ({ open, onClose }) => {
    const [selectedOption, setSelectedOption] = useState("wallet");
    const [showDoctorModal, setShowDoctorModal] = useState(false);

    const handleClose = () => {
        onClose();
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const handleProceedPayment = () => {
        // Open the doctor engagement payment modal
        setShowDoctorModal(true);
    };

    const handleDoctorModalClose = () => {
        setShowDoctorModal(false);
        onClose();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        maxWidth: "400px",
                        margin: "auto",
                        display: showDoctorModal ? "none" : "block", // <-- This line
                    }
                }}
                sx={{
                    "& .MuiBackdrop-root": {
                        backgroundColor: "rgba(76, 175, 80, 0.5)"
                    }
                }}
            >

                <DialogContent sx={{ p: 0, position: "relative" }}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            backgroundColor: "transparent",
                            color: "#666",
                            zIndex: 1,
                            "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)"
                            }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>

                    <Box sx={{ p: 4, textAlign: "center" }}>
                        <Box sx={{ mb: 3 }}>
                            <AccountBalanceWalletIcon
                                sx={{
                                    fontSize: 64,
                                    color: "#4CAF50",
                                    mb: 2
                                }}
                            />
                        </Box>

                        <Typography variant="h5" fontWeight={700} color="#333" mb={2}>
                            How would you like to pay?
                        </Typography>

                        <Typography
                            variant="body1"
                            color="#666"
                            mb={4}
                            sx={{ lineHeight: 1.6, fontSize: "16px" }}
                        >
                            Your payment is required to complete the booking but it will be kept until the Doctor has delivered service.
                        </Typography>

                        <Stack spacing={2} mb={4} alignItems="flex-start">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedOption === "wallet"}
                                        onChange={() => handleOptionChange("wallet")}
                                        sx={{ ml: 1 }}
                                    />
                                }
                                label="Pay from your ConnectingHealth Wallet"
                                sx={{
                                    justifyContent: "space-between",
                                    width: "100%",
                                    border: "1px solid #ccc",
                                    borderRadius: 2,
                                    px: 2,
                                    py: 1
                                }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedOption === "other"}
                                        onChange={() => handleOptionChange("other")}
                                        sx={{ ml: 1 }}
                                    />
                                }
                                label="Pay with other options"
                                sx={{
                                    justifyContent: "space-between",
                                    width: "100%",
                                    border: "1px solid #ccc",
                                    borderRadius: 2,
                                    px: 2,
                                    py: 1
                                }}
                            />
                        </Stack>

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: "#4CAF50",
                                color: "white",
                                py: 1.5,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "16px",
                                mb: 2,
                                "&:hover": {
                                    backgroundColor: "#45a049"
                                }
                            }}
                            onClick={handleProceedPayment}
                        >
                            Proceed with payment
                        </Button>

                        <Button
                            fullWidth
                            variant="text"
                            color="error"
                            onClick={handleClose}
                            sx={{
                                fontWeight: 500,
                                fontSize: "15px",
                                textTransform: "none"
                            }}
                        >
                            Cancel appointment
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Doctor Engagement Payment Modal */}
            <DoctorEngagementPaymentModal
                open={showDoctorModal}
                onClose={handleDoctorModalClose}
                amount={8000}
                doctorName="Dr. Wynn"
                email="abayomimusiliulat@gmail.com"
            />
        </>
    );
};

export default HowToPayModal;
